import React from "react";
import Snackbar from "@material-ui/core/Snackbar";
import Fade from "@material-ui/core/Fade";
import { SnackbarProps } from "@material-ui/core/Snackbar/Snackbar";
import { makeStyles } from "@material-ui/styles";

interface ActionProgressProps {
    open?: boolean;
    message?: SnackbarProps["message"];
}

export const ActionProgress: React.FunctionComponent<ActionProgressProps> = ({ open, message }) => {
    const classes = useStyles();
    return (
        <Snackbar
            open={open}
            TransitionComponent={Fade}
            ContentProps={{
                classes: {
                    root: classes.content,
                },
            }}
            message={message}
            className={classes.snackbar}
        />
    );
};

const useStyles = makeStyles({
    snackbar: {
        position: "absolute",
        inset: 0,
        transform: "none",
        alignItems: "normal",
    },
    content: {
        margin: 0,
        flexGrow: 1,
        borderRadius: 0,
        fontSize: "1.2rem",
    },
});
